import type { RSUAsset, ShareAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { calculateOnlyRSUsPortfolio, calculateOnlyStocksPortfolio } from "./partInPortfolio";
import { calculateRSUsYearlyYield, calculateShareYearlyYield } from "./yearlyYield";

export const calculateStocksCurrentYield = (
  userProduct: ShareAsset,
  currencies: {
    cashCurrency: Fiat;
    baseCurrency: Fiat;
  }
) => {
  const { cashCurrency, baseCurrency } = currencies;
  const stocks = userProduct?.stocksData || [];
  const yearlyYields = calculateShareYearlyYield(userProduct);
  const partsInPortfolio = calculateOnlyStocksPortfolio(
    userProduct,
    cashCurrency,
    baseCurrency
  );

  return stocks.reduce((sum, _, index) => {
    const yearlyYield = yearlyYields?.[index] || 0;
    const partInPortfolio = partsInPortfolio?.[index] || 0;

    return sum + yearlyYield * partInPortfolio;
  }, 0);
};


export const calculateRSUsCurrentYield = (
  userProduct: RSUAsset,
  currencies: {
    cashCurrency: Fiat;
    baseCurrency: Fiat;
  }
) => {
  const { cashCurrency, baseCurrency } = currencies;
  const stocks = userProduct?.rsuData || [];
  const yearlyYields = calculateRSUsYearlyYield(userProduct);
  const partsInPortfolio = calculateOnlyRSUsPortfolio(
    userProduct,
    cashCurrency,
    baseCurrency
  );

  return stocks.reduce((sum, _, index) => {
    const yearlyYield = yearlyYields?.[index] || 0;
    const partInPortfolio = partsInPortfolio?.[index] || 0;

    return sum + yearlyYield * partInPortfolio;
  }, 0);
};
